import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import Select from "react-select";
import moment from "moment";
import { API_URL } from "../..";

const AddOvertimeModal = ({ onClose, onSuccess }) => {
  const [employee, setEmployee] = useState(null);
  const [employees, setEmployees] = useState([]);

  const [date, setDate] = useState("");
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [payoutType, setPayoutType] = useState("hourly");
  const [hourlyRate, setHourlyRate] = useState("");
  const [fixedAmount, setFixedAmount] = useState("");
  const [calculatedAmount, setCalculatedAmount] = useState(0);

  // 👉Employees Fetch
  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        const res = await fetch(`${API_URL}/api/user/fetch`);
        const json = await res.json();
        if (json.message === "success") {
          setEmployees(
            json.data.map((u) => ({
              value: u.id,
              label: u.name,
            }))
          );
        }
      } catch (err) {
        console.log("Fetch employees error:", err);
      }
    };
    fetchEmployees();
  }, []);

  // 👉Hourly Calculation
  useEffect(() => {
    if (payoutType === "hourly" && startTime && endTime && hourlyRate) {
      const start = moment(startTime, "HH:mm");
      const end = moment(endTime, "HH:mm");
      const diffHours = moment.duration(end.diff(start)).asHours();

      if (diffHours > 0) {
        setCalculatedAmount(diffHours * Number(hourlyRate));
      } else {
        setCalculatedAmount(0);
      }
    }
  }, [startTime, endTime, hourlyRate, payoutType]);

  // 👉Submit Function
  const handleSubmit = async () => {

    if (!employee) {
      return alert("Select your employee!");
    }
    const user = JSON.stringify(localStorage.getItem('user'));
    const payload = {
      user_id: employee.value,
      date,
      start_time: startTime,
      end_time: endTime,
      payout_type: payoutType,
      amount: payoutType === "hourly" ? calculatedAmount : fixedAmount,
      admin_id:user.id
    };

    try {
      const res = await fetch(`${API_URL}/api/overtime/add/by-admin`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const json = await res.json();

      if (json.success) {
        alert("Overtime successfully added!");
        onSuccess();
        onClose();
      } else {
        alert(json.message || "Error occurred.");
      }
    } catch (err) {
      console.error(err);
      alert(err.message);
    }
  };

  return (
<Modal show onHide={onClose} size="lg" centered>

      <Modal.Header closeButton>
        <Modal.Title>Add New Overtime</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>

          {/* 🧑 Employee Select */}
          <Form.Group className="mb-3">
            <Form.Label>Employee</Form.Label>
            <Select
              options={employees}
              value={employee}
              onChange={setEmployee}
              placeholder="Select Employee"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Date</Form.Label>
            <Form.Control type="date" value={date} onChange={(e) => setDate(e.target.value)} />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Start Time</Form.Label>
            <Form.Control type="time" value={startTime} onChange={(e) => setStartTime(e.target.value)} />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>End Time</Form.Label>
            <Form.Control type="time" value={endTime} onChange={(e) => setEndTime(e.target.value)} />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Payout Type</Form.Label>
            <Form.Select value={payoutType} onChange={(e) => setPayoutType(e.target.value)}>
              <option value="hourly">Hourly</option>
              <option value="fixed">Fixed</option>
            </Form.Select>
          </Form.Group>

          {payoutType === "hourly" ? (
            <>
              <Form.Group className="mb-3">
                <Form.Label>Hourly Rate</Form.Label>
                <Form.Control type="number" value={hourlyRate} onChange={(e) => setHourlyRate(e.target.value)} />
              </Form.Group>

              <p className="fw-bold">
                Total Amount: <span className="text-success">£{calculatedAmount}</span>
              </p>
            </>
          ) : (
            <Form.Group className="mb-3">
              <Form.Label>Fixed Amount</Form.Label>
              <Form.Control type="number" value={fixedAmount} onChange={(e) => setFixedAmount(e.target.value)} />
            </Form.Group>
          )}
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>Cancel</Button>
        <Button variant="primary" onClick={handleSubmit}>Submit</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddOvertimeModal;
